import {Component, OnChanges, OnDestroy, OnInit, ViewChild, EventEmitter} from '@angular/core';
import {HeaderService} from '../core/services/header.service';
import {ActivatedRoute} from '@angular/router';
import {BaseComponent} from '../core/base.component';
import {Title} from '@angular/platform-browser';
import {AuthService} from '../core/security/auth.service';
import {BasicCallLogsGridComponent} from './basic-call-logs-grid.component';
import {RolesEnum} from '../core/security/roles.enum';
import {MatDialog} from '@angular/material/dialog';
import {
  MatCallLogsFilterDialogComponent
} from '../dialogs/mat-call-logs-filter/mat-call-logs-filter-dialog.component';
import {SelectedFilterValuesModel} from '../dialogs/grid-filter/selected-filter-values.model';
import {FilterOptionModel} from '../dialogs/grid-filter/filter-option.model';
import * as _ from 'lodash';
import {DateRangeService} from '../core/services/date-range.service';
import {ReportsService} from '../reports/reports.service';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../dialogs/grid-filter/filter-row-additional-content.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-basic-call-logs',
    templateUrl: './basic-call-logs.component.html',
    styleUrls: ['./basic-call-logs.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        MatButton,
        MatIcon,
        BasicCallLogsGridComponent,
    ],
})
export class BasicCallLogsComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  filterChangeEvent = new EventEmitter<any>();
  selectedFilterChange = new EventEmitter<SelectedFilterValuesModel[]>();

  selectedFilter: SelectedFilterValuesModel[] = new Array<SelectedFilterValuesModel>();
  filterOptions: FilterOptionModel[] = [];

  @ViewChild('callLogsGrid') callLogsGrid: BasicCallLogsGridComponent;

  constructor(public reportsService: ReportsService,
              public dateRangeService: DateRangeService,
              public dialog: MatDialog,
              route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService) {
    super(route, headerService, titleService, authService);

    this.editRoles = [RolesEnum.CallLogs_Edit, RolesEnum.CallLogs_Delete];
    this.deleteRoles = [RolesEnum.CallLogs_Delete];
  }

  async ngOnInit() {
    await super.ngOnInit();

    this.headerService.hideSearchInput();

    if (this.reportsService.accountsLookup?.length > 0) {
      this.initFilterOptions();
    } else {
      this.reportsService.lookupUpdatedEvent.subscribe(() => {
        this.initFilterOptions();
      });
    }
  }

  ngOnChanges() {

  }

  onSelectedItemsChanged($event: SelectedFilterValuesModel[]) {
    this.selectedFilter = $event;
  }

  onFilterChanged(filter: any) {
    let extensions = [];
    let accounts = [];

    if (filter['extensions']) {
      extensions = _.union(extensions, filter['extensions']);
      filter['extensions'] = undefined;
    }
    if (filter['departments']) {
      const departments = this.reportsService.getDepartmentsExtensions(filter['departments']);
      extensions = _.union(extensions, departments);
      filter['departments'] = undefined;
    }
    if (filter['agentGroup']) {
      accounts = _.union(accounts, filter['agentGroup']);
      filter['agentGroup'] = undefined;
    }
    if (filter['huntGroup']) {
      accounts = _.union(accounts, filter['huntGroup']);
      filter['huntGroup'] = undefined;
    }
    if (filter['attendants']) {
      accounts = _.union(accounts, filter['attendants']);
      filter['attendants'] = undefined;
    }
    if (filter['durationTo']) {
      filter['durationTo'] = filter['durationTo'] * 1000;
    }
    if (filter['durationFrom']) {
      filter['durationFrom'] = filter['durationFrom'] * 1000;
    }

    filter['extensions'] = extensions;
    filter['groupAccounts'] = accounts;

    this.filterChangeEvent.emit(filter);
  }

  openFilterDialog() {
    console.log('open filter dialog');
    const dialogRef = this.dialog.open(MatCallLogsFilterDialogComponent, {
      width: '600px',
      height: '80%',
      data: {
        filter: this.selectedFilter
      }
    });

    dialogRef.afterClosed().subscribe(async (result: SelectedFilterValuesModel[]) => {
      if (result) {
        this.selectedFilterChange.emit(result);
      }
    });
  }

  async openExportDialog() {
    await this.callLogsGrid.onExportClick();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.headerService.hideSearchInput();
    this.headerService.searchText.next('');
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'numberFrom',
        multiValue: false,
        showAlways: true,
        title: 'From Number',
        type: 'phoneNumber',
      },
      {
        filterKey: 'numberTo',
        multiValue: false,
        showAlways: true,
        title: 'To Number',
        type: 'phoneNumber',
      },
      {
        filterKey: 'durationFrom',
        multiValue: false,
        showAlways: true,
        title: 'Duration From',
        type: 'number',
      },
      {
        filterKey: 'durationTo',
        multiValue: false,
        showAlways: true,
        title: 'Duration To',
        type: 'number',
      },
      {
        filterKey: 'statuses',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Status',
        displayValue: 'Answered',
        value: 'Answered',
        searchText: 'Call Status: Answered',
      },
      {
        filterKey: 'statuses',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Status',
        displayValue: 'Missed',
        value: 'Missed',
        searchText: 'Call Status: Missed',
      },
      {
        filterKey: 'statuses',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Status',
        displayValue: 'Mailbox',
        value: 'Mailbox',
        searchText: 'Call Status: Mailbox',
      },
      {
        filterKey: 'statuses',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Status',
        displayValue: 'Login',
        value: 'Login',
        searchText: 'Call Status: Login',
      },
      {
        filterKey: 'statuses',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Status',
        displayValue: 'Logout',
        value: 'Logout',
        searchText: 'Call Status: Logout',
      },
      {
        filterKey: 'types',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Type',
        displayValue: 'Incoming',
        value: 'isIncoming',
        searchText: 'Call Type: Incoming',
      },
      {
        filterKey: 'types',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Type',
        displayValue: 'Outgoing',
        value: 'isOutgoing',
        searchText: 'Call Type: Outgoing',
      },
      {
        filterKey: 'types',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Call Type',
        displayValue: 'Internal',
        value: 'isLocal',
        searchText: 'Call Type: Internal',
      },
      {
        filterKey: 'exclude',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Exclude',
        displayValue: 'Agent Groups',
        value: 'isGroup',
        searchText: 'Exclude: Agent Groups',
      },
      {
        filterKey: 'exclude',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Exclude',
        displayValue: 'Hunt Groups',
        value: 'isHunt',
        searchText: 'Exclude: Hunt Groups',
      },
    ];

    if (this.reportsService.extensionsLookup.length > 0) {
      for (const item of this.reportsService.extensionsLookup) {
        this.filterOptions.push({
          filterKey: 'extensions',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'User',
          displayValue: item.text,
          value: item.value,
          searchText: `User: ${item.text}`,
        });
      }
    }

    if (this.reportsService.departmentsLookup.length > 0) {
      for (const item of this.reportsService.departmentsLookup) {
        this.filterOptions.push({
          filterKey: 'departments',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Department',
          displayValue: item.text,
          value: item.value,
          searchText: `Department: ${item.text}`,
        });
      }
    }

    if (this.reportsService.groupsLookup.length > 0) {
      for (const item of this.reportsService.groupsLookup) {
        this.filterOptions.push({
          filterKey: 'agentGroup',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Agent Group',
          displayValue: item.text,
          value: item.value,
          searchText: `Agent Group: ${item.text}`,
        });
      }
    }

    if (this.reportsService.huntGroupsLookup.length > 0) {
      for (const item of this.reportsService.huntGroupsLookup) {
        this.filterOptions.push({
          filterKey: 'huntGroup',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Hunt Group',
          displayValue: item.text,
          value: item.value,
          searchText: `Hunt Group: ${item.text}`,
        });
      }
    }

    if (this.reportsService.attendantsLookup.length > 0) {
      for (const item of this.reportsService.attendantsLookup) {
        this.filterOptions.push({
          filterKey: 'attendants',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Attendant',
          displayValue: item.text,
          value: item.value,
          searchText: `Attendant: ${item.text}`,
        });
      }
    }
  }
}
